import * as types from './interviewPaymentStatusTypes'

const initialState = {
  paymentStatusList: [],
  isFetching: false
}

const interviewPaymentStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_INTERVIEW_PAYMENT_STATUS_REQUESTED:
      return { ...state, isFetching: true }
    case types.FETCH_INTERVIEW_PAYMENT_STATUS_SUCCEEDED:
      return { ...state, paymentStatusList: action.payload, isFetching: false }
    case types.FETCH_INTERVIEW_PAYMENT_STATUS_FAILED:
      return { ...state, isFetching: false }
    default:
      return state
  }
}

export default interviewPaymentStatusReducer